export enum CasheirFieldConfigurationKeys {
  Field = 'field',
  Direction = 'direction',
  Platform = 'platform',
  Theme = 'theme',
  Version = 'version',
  PaymentMethodId = 'paymentMethodId',
}

export enum IframeTypes {
  Leader = 'leader',
  Field = 'field',
}

export enum FieldNames {
  Cvv = 'cvv',
  Expiry = 'expirationDate',
  CardNumber = 'creditcardNumber',
  CardHolder = 'cardHolder',
}

export const IFRAME_FIELDS: FieldNames[] = [
  FieldNames.Cvv,
  FieldNames.Expiry,
  FieldNames.CardNumber,
  FieldNames.CardHolder,
];

export enum CashierMessages {
  LoadPliromyTokenizer = 'loadPliromyTokenizer',
  CashierData = 'cashierData',
  SendRequestForFinteqHubMethods = 'sendRequestForFinteqHubMethods',
  GetEncryptedFieldsData = 'getEncryptedFieldsData',
}

export enum LeaderIframeMessages {
  LeaderToField = 'leaderToField',
  PreprocessorLoaded = 'preprocessorLoaded',
  FinteqHubPaymentProcessed = 'finteqHubPaymentProcessed',
  FieldsDataToCashier = 'fieldsDataToCashier',
  FieldsDataToProcessingRequest = 'fieldsDataToProcessingRequest',
  PliromyTokenizer = 'pliromyTokenizer',
  DisabledFields = 'disabledFields',
  FieldsDataToLeader = 'fieldsDataToLeader',
}

export const BROADCAST_CHANNEL = 'leader-field-channel';
